
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M496 96h-64l-7.16-14.31A32 32 0 00396.22 64H326.6l-27.28-27.28c-3.26-3.26-7.27-4.72-11.2-4.72-8.23 0-16.12 6.39-16.12 16.03V224H160c-19.59 0-37.76 5.93-52.95 16H80c-26.47 0-48-21.53-48-48 0-8.84-7.16-16-16-16s-16 7.16-16 16c0 43.24 34.53 78.36 77.46 79.74C69.12 285.97 64 302.32 64 320v160c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96h96v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V240h32c35.35 0 64-28.65 64-64v-64c0-8.84-7.16-16-16-16zM384 480h-64V352H160v128H96V320c0-35.29 28.71-64 64-64h118.06L384 282.48V480zm96-304c0 17.64-14.36 32-32 32h-64v41.52l-80-20V86.66l9.34 9.34h82.88l16 32H480v48zm-112-48c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"}})])
          )
        }
      }
    